module.exports = __webpack_public_path__ + "img/cooper_run_card.483d7910.svg";